import React from "react";
import Lottie from "react-lottie";
import logo from "../../../asset/logo.png";
import flyingPaperPlaneAnimation from "../../../lottie-files/flying-paper-plane.json";

const SPLASH_ANIMATION_SIZE = 120;
const NETPAD_LOGO_ALT_TEXT = "Netpad logo";
const NETPAD_BRAND_NAME = "Netpad.click";

const SplashScreenAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: flyingPaperPlaneAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-surface">
      <div className="flex flex-col items-center justify-center gap-1">
        <Lottie
          options={defaultOptions}
          height={SPLASH_ANIMATION_SIZE}
          width={SPLASH_ANIMATION_SIZE}
        />
        <div className="flex items-center justify-center gap-2">
          <img
            src={logo}
            alt={NETPAD_LOGO_ALT_TEXT}
            className="h-9 w-9"
          />
          <span className="font-sen text-2xl text-primary">
            {NETPAD_BRAND_NAME}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreenAnimation;
